/** Maps menu item IDs to their corresponding section_statuses API keys. */
export const SECTION_STATUS_KEY_MAP: Record<string, string> = {
  'dati-societari': 'general-data',
  'informazioni-di-contatto': 'contacts',
  'fatture-elettroniche-xml': 'fatture-elettroniche',
  'fatture-cartacee-pdf': 'fatture-cartacee',
  'scritture-libri-contabili': 'libri-contabili',
  'altri-documenti-rilevanza-contabile': 'altri-documenti',
  'dichiarazioni-comunicazioni-amministrazione-finanziaria': 'amministrazione-finanziaria',
  'messaggi-posta-elettronica-certificata-pec': 'pec',
  'libro-unico-del-lavoro-lul': 'lul',
  'altre-tipologie-documentali': 'altre-tipologie',
  'rentri-registro-elettronico-tracciabilita-rifiuti': 'rentri',
};
